// test2544
(2544 && 0);
